import React from 'react';

import SCIsReferent from '../../components/Prospecting/SCIsReferent/SCIsReferent.module';

function SCIsReferentView() {
  return (
    <SCIsReferent />
  );
}

export default SCIsReferentView;


